<template>

  <div class="page-content">
    <header-inner/>
    <wrapper :lineBorders="true" :lineCenter="true" class="page--top page--bottom">

      <div class="video-container">
        <article-video youtube-url="NXtrSE9wLeA" cover="/images/_tmp/product.jpg"/>
      </div>

      <section class="article-description typography-text">
        <h1 class="text-blue-2">Брендирование входа и кассовой зоны</h1>
        <p>Реклама на входе и в кассовой зоне создает «зону доминирования» рекламируемого продукта и обеспечивает
          гарантированный контакт со всеми покупателями. Брендированные элементы хорошо видны как при входе, так и при
          выходе из торгового зала. Возможности: рекламные поверхности на разделителях покупок, стикеры на кассовых
          лентах, продуктовых тележках, брендирование ограждений и антенн безопасности и др.
        </p>
      </section>

      <section class="facilities typography-text">
        <h1 class="text-blue-2 full-width">Возможности</h1>
        <ol>
          <li>
            100% контакт со всей аудиторией торговой точки
          </li>
          <li>
            Стимурирует рост продаж
          </li>
          <li>
            Разнообразные креативные возможности
          </li>
          <li>
            Создание зоны доминирования рекламируемого бренда
          </li>
          <li>
            Длительный контакт с рекламным сообщением
          </li>
        </ol>
      </section>

      <section class="slider-section" v-show="slides">
        <slider :autoplay="true" ref="slider">
          <image-slide v-for="(slide, id) in slides" :key="id" :image="slide.image"/>
        </slider>
      </section>

      <section class="also-interesting">
        <h1 class="text-blue-2 half">Вам может быть интересно</h1>
        <div class="card-list">
          <card-product-small v-for="(news) in newsRelated" :key="news.id"
                              :title="news.title"
                              :date="news.date"
                              :image="news.image"
                              :id="news.id"
                              :link="news.url"
          />
        </div>
      </section>

    </wrapper>
  </div>

</template>

<script>

  import HeaderInner from "../../../components/header/HeaderInner";
 // import Slider from "../../../components/shared/sliders/Slider";
  import ImageSlide from "../../../components/shared/sliders/ImageSlide";
  import ArticleVideo from "../../../components/articles/ArticleVideo";
  import CardProductSmall from "../../../components/shared/cards/CardProductSmall";

  export default {
    head: {
      title: 'Особая страница'
    },
    data() {
      return {
        slides: [
          {
            image: '/images/_tmp/2.jpg'
          },
          {
            image: '/images/_tmp/3.jpg'
          },
        ],
      };
    },
    watch: {
      slides() {
        this.$refs.slider.rebuild();
      },
    },
    computed: {
      newsRelated() {
        return this.$store.state.content.entities.cases.items;
      },
    },
    mounted() {
      this.$store.dispatch('content/loadEntities', { sID: 'cases' });
    },
    components: {
      CardProductSmall,
      ArticleVideo,
      ImageSlide,
     // Slider,
      HeaderInner
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/vars', '../../../assets/mixins';

  .facilities {
    padding: 145px 0;
    @media(max-width: 900px) {
      padding: 65px 0;
    }
    @media(max-width: 600px) {
      padding: 0;
    }
    li {
      @include font-size(26px, 36px);
      @media(max-width: 600px) {
        @include font-size(20px, 26px);
      }
    }
  }

  .also-interesting {
    padding: 145px 0 0;
    @media(max-width: 900px) {
      padding: 65px 0 0;
    }
    @media(max-width: 600px) {
      padding: 35px 0 0;
    }
  }


</style>



// WEBPACK FOOTER //
// pages/products/_category/other.vue